var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.blok.title)?_c('h1',[_vm._v(_vm._s(_vm.blok.title))]):_vm._e(),_vm._v(" "),(_vm.blok.text)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.$md.render(_vm.blok.text))}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }